import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { FormattedCurrency } from '../../../../iwIntlProvider/FormattedCurrency';
import { PROCESSING_PAYMENT_MODAL_RETURN_TO_DASHBOARD } from '../ProcessingPaymentModal.actions';
import { Content } from '../Content';
import { SuccessCircleSVG } from '../../../../svgComponents/successCircleSVG';
import { DRAW_DOWN_MODE } from '../../../funding/ConfirmFundingView/ConfirmFunding.sagas';
import messages from './Success.messages';
import styles from './Success.module.css';
import { RootState } from '@iwProvider/configureStore';
import { Dispatch } from 'redux';

const mapStateToProps = (state: RootState) => ({
    ...state.processingPaymentModal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToHome: () =>
        dispatch({ type: PROCESSING_PAYMENT_MODAL_RETURN_TO_DASHBOARD })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;
const Success = ({
    goToHome,
    senderLogo,
    receiverLogo
}: PropsFromRedux & {
    senderLogo: string;
    receiverLogo: string;
}) => {
    return (
        <Content
            title={<SuccessTitle />}
            icon={
                <span className={styles.processingDirectionSuccess}>
                    <SuccessCircleSVG
                        className={styles.SuccessCircleSVG}
                        data-testid="success-payment-icon"
                    />
                </span>
            }
            senderLogo={senderLogo}
            receiverLogo={receiverLogo}
            ctaOnClick={goToHome}
            ctaText={<FormattedMessage {...messages.returnToDashboard} />}
        />
    );
};

const SuccessTitle = connect(mapStateToProps)(({
    mode,
    amount,
    paymentMethod
}) => {
    const formattedAmount = <FormattedCurrency value={amount!} />;

    if (mode !== DRAW_DOWN_MODE) {
        return (
            <>
                <p>
                    <FormattedMessage
                        {...messages.repayConfirmed}
                        values={{
                            amount: formattedAmount,
                            paymentMethod: paymentMethod
                        }}
                    />
                </p>
                <p className={styles.subtitle}>
                    <FormattedMessage {...messages.repayConfirmedSubtitle} />
                </p>
            </>
        );
    }

    return (
        <FormattedMessage
            {...messages.drawDownConfirmed}
            values={{
                amount: formattedAmount,
                paymentMethod: paymentMethod
            }}
        />
    );
});

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(Success);
